import React from "react";
import {FieldPrefix, PrefixedError, PrefixedField} from "../fields/PrefixField";
import InputField from "../fields/InputField";
import {composeValidators, email, limit, required} from "../../helpers/ValidateHelper";

function LoginForm({onForgotPassword}) {
    return <FieldPrefix prefix="login">
        <div className="form-group">
            <div className="form-label">Email <span className="rq">*</span></div>
            <PrefixedField
                name="email"
                type="email"
                component={InputField}
                placeholder="e.g. Email@address.com"
                className="control-input auth-form-field"
                autoComplete="email"
                inputProps={{
                    inputMode: 'email',
                    autoCorrect: 'off',
                    spellCheck: 'false',
                    autoCapitalize: 'none',
                }}
                validate={composeValidators(
                    required('Please provide an email'),
                    email('Please provide a valid email'),
                    limit('Maximum {limit} characters allowed. You\'ve used {count}.', 320)
                )}
            />
            <PrefixedError name="email" />
        </div>
        <div className="form-group">
            <div className="form-label">Password <span className="rq">*</span></div>
            <PrefixedField
                name="password"
                type="password"
                component={InputField}
                placeholder="your password"
                className="control-input auth-form-field"
                autoComplete="current-password"
                validate={composeValidators(
                    required('Please provide a password'),
                    limit('Maximum {limit} characters allowed. You\'ve used {count}.', 255)
                )}
            />
            <PrefixedError name="password" />
            <a onClick={onForgotPassword} className="forgot-password reset-password-btn_v3">
                Forgot password?
            </a>
        </div>
    </FieldPrefix>
}

export default LoginForm;